/**
 * The other front door.
 *
 * Composer is a separate app on its own host with the same sign-in. The
 * address is a constant rather than an environment variable on purpose: it
 * has never varied between environments, `firebase.json` redirects to the same
 * literal, and a `requireEnv` for it would have to be threaded through CI and
 * both emulator suites for a value that nothing ever sets differently.
 */
export const COMPOSER_URL = "https://composer.spontar.com";
